import React from 'react';
import CRM from './CRM';

export default function CrmWorkspace() {
  return <CRM />;
}
